import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  constructor(public http:HttpClient) { }
  getRecipients(page = 1){
    return this.http.get(environment.api_link+"/api/auth/get-recipient?page="+page)
  }

  createContact(data){
    //console.log("final data",data)
    return this.http.post(environment.api_link+"/api/auth/save-contact",data)
  }

  getBankName(ifsc){
    return this.http.get(environment.api_link+"/api/get_ifsc/"+ifsc)
  }

  getBranch(bankid){
    return this.http.get(environment.api_link+"/api/get_branchs/"+bankid)
  }

  getName(bankcode,account_numner){
    return this.http.get(environment.api_link+"/api/get_account_holder_name/"+bankcode+"/"+account_numner)
  }

  getProviders(currency,code='AA'){
    return this.http.get(`${environment.api_link}/api/auth/get_provider/${currency}/${code}`)
  }
}
